import { render, staticRenderFns } from "./daicb.vue?vue&type=template&id=3274053e&scoped=true&"
import script from "./daicb.vue?vue&type=script&lang=js&"
export * from "./daicb.vue?vue&type=script&lang=js&"
import style0 from "./daicb.vue?vue&type=style&index=0&id=3274053e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274053e",
  null
  
)

export default component.exports